import type { PreloadedQuery } from 'react-relay';
import { forgeProjectModuleResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { staticSidebarShortcutsResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-sidebar-shortcuts/index.tsx';
import { fieldsResource } from '@atlassian/jira-router-resources-business-fields/src/index.tsx';
import { navigationResource } from '@atlassian/jira-router-resources-business-navigation/src/index.tsx';
import {
	overviewDetailsResource,
	type OverviewDetailsResource,
} from '@atlassian/jira-router-resources-business-overview-details/src/index.tsx';

import {
	// eslint-disable-next-line camelcase
	DEPRECATED_DO_NOT_USE_projectDetailsResource,
	type ProjectDetailsResource,
} from '@atlassian/jira-router-resources-business-project-details/src/index.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { projectContextResource } from '@atlassian/jira-router-resources-project-context/src/services/project-context/index.tsx';
import { licenseDetailsResource_DEPRECATED_DO_NOT_USE } from '@atlassian/jira-router-resources-business-license-details/src/index.tsx';
import { projectCreatePermissionsResource } from '@atlassian/jira-router-resources-project-permissions/src/services/project-permissions/index.tsx';
import { projectThemeResource } from '@atlassian/jira-router-resources-project-theme/src/index.tsx';
import type { ThemeSetterQuery } from '@atlassian/jira-relay/src/__generated__/ThemeSetterQuery.graphql';
// eslint-disable-next-line jira/import/file-extension-required
import type { LicenseDetailsResourceType } from '@atlassian/jira-router-resources-business-license-details/src/types';
// eslint-disable-next-line jira/import/file-extension-required
import type { NavigationResourceType } from '@atlassian/jira-router-resources-business-navigation/src/types';
// eslint-disable-next-line jira/import/file-extension-required
import type { ProjectPermissions } from '@atlassian/jira-router-resources-project-permissions/src/services/project-permissions/types';
import type { RouteResource } from '@atlassian/react-resource-router';

export const getBusinessProjectResources = (): (
	| RouteResource<ProjectDetailsResource>
	| RouteResource<PreloadedQuery<ThemeSetterQuery, Record<string, unknown>>>
)[] => [
	// eslint-disable-next-line camelcase
	DEPRECATED_DO_NOT_USE_projectDetailsResource,
	projectThemeResource,
];

export const getProjectViewResources = (): RouteResource[] => [
	...getBusinessProjectResources(),
	...getNavigationResources(),
	// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
	projectContextResource,
	forgeProjectModuleResource,
	staticSidebarShortcutsResource,
	staticProjectSidebarNavigationResource,
	staticProjectSidebarConnectAddonsNavigationResource,
	// end of resources expanded from getNavigationSidebarProjectResource
	fieldsResource,
];

/**
 * @deprecated Overviews are phased out in favor of Plans
 */
export const getBusinessOverviewResources = (): (
	| RouteResource<PreloadedQuery<ThemeSetterQuery, Record<string, unknown>>>
	| RouteResource<ProjectPermissions | null>
	| RouteResource<NavigationResourceType>
	| RouteResource<LicenseDetailsResourceType>
	| RouteResource<OverviewDetailsResource>
)[] => [
	projectCreatePermissionsResource,
	navigationResource,
	licenseDetailsResource_DEPRECATED_DO_NOT_USE,
	overviewDetailsResource,
	projectThemeResource,
];

/**
 * @deprecated Overviews are phased out in favor of Plans
 */
export const getOverviewViewResources = (): RouteResource[] => [
	...getBusinessOverviewResources(),
	...getNavigationResources(),
	fieldsResource,
];
